const setSrc = ($el) => {
	if ($el.dataset.src) $el.src = $el.dataset.src;
	if ($el.dataset.srcset) $el.srcset = $el.dataset.srcset;

	// check if element is a video or a source with video as parent
	if (
		$el.tagName === 'VIDEO' ||
		($el.tagName === 'SOURCE' && $el.parentNode.tagName === 'VIDEO')
	) {
		// get video element
		const $video = $el.tagName === 'VIDEO' ? $el : $el.parentNode;

		// check if video should autoplay, this can not be enabled as long as no 'src' is set yet,
		// so we do it after setting the src here
		if ($video.dataset.autoplay) {
			const handleCanPlay = () => {
				$video.play();
				$video.removeEventListener('canplay', handleCanPlay);
			};

			$video.addEventListener('canplay', handleCanPlay);
		}

		$video.load();
	}
};

const init = ($root = document, forceLoad = false) => {
	// Loop over our lazy-loaded elements
	$root
		.querySelectorAll(
			'img[data-src],video[data-src],iframe[data-src],source[data-src],source[data-srcset]'
		)
		.forEach($lazyEl => {
			const isInCarousel = !!$lazyEl.closest('.js-slider, .js-hero-carousel-slider, .js-product-carousel, .js-card-overview-slider');
			if (!isInCarousel || forceLoad) {
				setSrc($lazyEl);
			}
		});
};

export default {
	init
};
